import { render } from "./RoadmapInitiative.vue?vue&type=template&id=67800314"
import script from "./RoadmapInitiative.vue?vue&type=script&lang=js"
export * from "./RoadmapInitiative.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__